import getValueReduxUtil from 'modules/redux/utils/get-value'
import { DAY_KEY } from '@gymaholic/packages'
import { hasWorkoutsDayUtil } from 'modules/day/utils/hasWorkouts/index.js'
import { isCompletedDayUtil } from 'modules/day/utils/isCompleted/index.js'
import { getDeepByIdDaySelector } from 'modules/day/redux/selectors/getDeepById/index.js'
import { getDaysDeepByIdPlanSelector } from 'modules/day/redux/selectors/getDaysDeepById/index.js'

export const isCompletedByIdDaySelector = id => (state) => {
  const day = getDeepByIdDaySelector(id)(state)
  const dayOrder = getValueReduxUtil(day, DAY_KEY.ORDER)
  const days = getDaysDeepByIdPlanSelector()(state)

  const hasCompletedADayWithWorkoutsBefore = days.some(dayItem => {
    return (
      getValueReduxUtil(dayItem, DAY_KEY.ORDER) < dayOrder &&
      hasWorkoutsDayUtil(dayItem) &&
      isCompletedDayUtil({ day: dayItem })
    )
  })

  return isCompletedDayUtil({
    day,
    hasCompletedADayWithWorkoutsBefore
  })
}
